import { AvatarSize } from '@eventbrite/eds-avatar';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    LISTING_HEAP_IDS,
    LISTING_HEAP_PAGE_AREA_IDS,
} from '../../../../constants';
import { useOrganizerBasicInfo } from '../../../../contexts/OrganizerContext';
import { useScrollDispatch } from '../../../../contexts/ScrollContext';
import { FeatureFlags } from '../../../../types';
import { useTrackComponent } from '../../../hooks/useTrackComponent';
import { FollowButton } from '../../FollowButton/FollowButton';
import { LSClickableAvatarWithBadge } from './ListingsAvatarWithBadge';
import './OrganizerTrustSignalInfo.scss';

interface OrganizerTrustSignalProps {
    featureFlags?: FeatureFlags;
    isMobile?: boolean;
    pageArea?: string;
}

export type TOrganizerTrustSignalInfoProps = OrganizerTrustSignalProps;

export const OrganizerTrustSignalInfo = ({
    pageArea,
    featureFlags,
    isMobile,
}: TOrganizerTrustSignalInfoProps) => {
    const { name } = useOrganizerBasicInfo();
    const dispatch = useScrollDispatch();
    const ref = React.useRef<HTMLDivElement>(null);

    useTrackComponent({
        ref: ref,
        heap: {
            eventName: LISTING_HEAP_IDS.ORGANIZER_TRUST_SIGNAL_VIEW,
            eventBucketLabel: 'Views on the Organizer Trust Signal section',
        },
    });

    const renderFollowButton = () => (
        <FollowButton
            pageArea={
                pageArea || LISTING_HEAP_PAGE_AREA_IDS.SIMPLIFIED_ORGANIZER
            }
            variant="white"
            iconSize="xsmall"
        />
    );

    return (
        <section
            className="organizer-info"
            aria-label={gettext('Organizer profile').toString()}
            ref={ref}
            data-testid="top-organizer-component"
        >
            <div
                className="organizer-info__profile"
                data-testid="top-organizer-component-profile"
            >
                <LSClickableAvatarWithBadge
                    featureFlags={featureFlags}
                    isMobile={isMobile}
                    avatarSize={AvatarSize.xxsmall}
                    verifiedBadgeIconSize={12}
                />
                {name && (
                    <span className="organizer-info__name-by">
                        {gettext('By')}{' '}
                        <strong
                            className="organizer-info__name-link"
                            onClick={() => {
                                dispatch({
                                    action: 'scroll',
                                    target: 'organizerPanel',
                                });
                            }}
                            style={{ cursor: 'pointer' }}
                            data-testid="top-organizer-component-name"
                        >
                            {name}
                        </strong>
                    </span>
                )}
            </div>
            <div className="organizer-listing-info-variant-b__follow-button-responsive">
                {renderFollowButton()}
            </div>
        </section>
    );
};
